// Vuex
// import store from '@/store.js';
// i18n
// import i18n from '@/i18n';
// Self-made Snackbar
// import snackbar from '@/plugins/snackbar';
// import consts from '@/consts.js'

import Request from './request';

async function getReturnableView(id) {// 根据采购单ID获取退货商品
    return Request('get', "api/return-purchases/get-returnable-view/" + id);
}

async function getReturnPurchaseStockIns(data) {
    return Request('get', "api/return-purchases/get-return-purchase-stock-ins", data);
}

async function addPreview(data) {
    // 新建退货单单预览
    return Request('post', 'api/return-purchases/add-view', data)
}

async function add(data) {// 新建退货单
    return Request('post', "api/return-purchases/add", data);
}

async function fetch(data) {
    return Request('get', "api/return-purchases", data);
}

async function fetchOne(id, data) {// 获取单个
    return Request('get', "api/return-purchases/" + id, data);
}

async function fetchRelations(data) {// 获取退货单相关单据
    return Request('get', "api/return-purchases/relations", data);
}

async function approve(id) {// 审核退货单
    return Request('get', "api/return-purchases/approve/" + id);
}

async function cancel(id) {// 作废退货单
    return Request('get', "api/return-purchases/cancel/" + id);
}

async function confirmPreview(data) {
    // 确认退货单预览
    return Request('patch', 'api/return-purchases/confirm-view', data)
}

async function editPreview(data) {
    // 编辑退货单预览
    return Request('patch', 'api/return-purchases/edit-view', data)
}

async function confirm(data) {// 确认退货单
    // data = delSomeFields(data);// 去除过多杂项
    return Request('patch', "api/return-purchases/confirm/" + data.id, data);
}

async function edit(data) {// 编辑退货单
    // data = delSomeFields(data);// 去除过多杂项
    return Request('patch', "api/return-purchases/edit/" + data.id, data);
}

export default {
    getReturnableView,
    getReturnPurchaseStockIns,
    addPreview,
    add,
    fetch,
    fetchOne,
    fetchRelations,
    approve,
    cancel,
    confirmPreview,
    editPreview,
    confirm,
    edit,
};